/* Similar to the current one, however focus on how the run is loaded */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../utils/withRouter';
import {loadDriverRuns} from '../../actions/runActions';
import DriverRunsView from "./DriverRunsView";
import { GetUserLocation, isNullEmptyOrWhitespace, IsNullOrUndefined} from "../../constants";
import ScaleStatusView from "../Scales/ScaleStatusView";


class DriverRunsPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.loadRuns = this.loadRuns.bind(this);
    }

    loadRuns() {
        this.props.dispatch(loadDriverRuns(true));
    }

    componentDidMount(){
        this.loadRuns();
        if(!this.props.children){
            window.scrollTo(0,0);
        }
    }

    render() {
        let {account, userLocation, weightScales, hasRunId, truckData} = this.props;
        let mainContent = null;
        let {latitude, longitude, hasUserLocation} = GetUserLocation(userLocation);        
        
        if(IsNullOrUndefined(account) || IsNullOrUndefined(account.user) || isNullEmptyOrWhitespace(account.user.userName)){
            mainContent = (<div>User loading...</div>);
        }
        
        if(mainContent === null && this.props.children){
            mainContent = (<div>{this.props.children}</div>);
        }
        else if(mainContent === null){
            mainContent = (<DriverRunsView
                runs={this.props.runs}
                loadRuns={this.loadRuns}
                userName={this.props.account.user.userName}
                account={account}
            />);
        }
        return (<div>
            <div className={"mb-1"}>
            {hasUserLocation ?
                <div className={"row"}>
                    <div className={"col-12 text-success"}>
                        <b>Current device location</b>&nbsp;&nbsp;<a href={`http://maps.google.com/maps?&z=21&q=${latitude}+${longitude}`}
                                                   target={'_blank'}>{`${latitude}, ${longitude}`}</a>
                    </div>
                </div>
                :
                <div className={"row"}>
                    <div className={"col-12 text-danger"}>
                        Device location not on!
                    </div>
                </div>
            }
            </div>
            { !hasRunId && <div className={"mb-1"}>
                <ScaleStatusView weightScales={weightScales} truckData={truckData} />
            </div> }
            
            {mainContent}
        </div>);
    }
}

DriverRunsPage.propTypes = {
    runs: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    weightScales: PropTypes.object.isRequired,
    hasRunId: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps){
    let runId = parseInt(ownProps.routeParams.id);

    return {
        account: state.account,
        runs: state.driverRuns,
        userLocation: state.location,
        weightScales: {
            connected: state.truckData.weight.connected,
            currentWeight: state.truckData.weight.currentWeight,
            currentRawWeight: state.truckData.weight.currentRawWeight,
            truckNumberPlate: state.truckData.truckNumberPlate,
            errorReason: state.truckData.errorReason,
        },
        hasRunId: runId > 0,
        truckData: state.truckData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DriverRunsPage));



